function initCovour() {
if (document.querySelector('#contact-dialog')) {
const dialog = document.querySelector('#contact-dialog');
if (dialog.dataset.initialized) return;
dialog.dataset.initialized = 'true';
let opener;
if (!window.covourContactBound) {
window.covourContactBound = true;
document.addEventListener('click', event => {
 const button = event.target.closest('[data-contact]');
 const current = document.querySelector('#contact-dialog');
 if (button && current) { window.covourOpener = button; current.showModal(); document.body.classList.add('modal-open'); }
});
}
document.querySelector('[data-contact-done]')?.addEventListener('click', () => dialog.close());
document.querySelector('.close').addEventListener('click', () => dialog.close());
dialog.addEventListener('click', event => {
  const rect = dialog.getBoundingClientRect();
  if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
});
dialog.addEventListener('close', () => {
  document.body.classList.remove('modal-open');
  window.covourOpener?.focus();
});
const result = document.querySelector('[data-form-result]');
if (result) {
  dialog.showModal();
  document.body.classList.add('modal-open');
  result.focus();
}

const contactForm = document.querySelector('#contact-form');
if (contactForm) {
  const fields = [...contactForm.querySelectorAll('input[required], textarea[required]')];
  const showFieldError = (field) => {
    const index = fields.indexOf(field);
    if (index < 0) return;
    const errorId = `contact-error-${index}`;
    let error = document.getElementById(errorId);
    if (!error) {
      error = document.createElement('span');
      error.id = errorId;
      error.className = 'field-error';
      field.insertAdjacentElement('afterend', error);
      field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), errorId].filter(Boolean).join(' '));
    }
    const invalid = !field.validity.valid;
    field.setAttribute('aria-invalid', String(invalid));
    error.hidden = !invalid;
    error.textContent = field.validity.valueMissing ? 'Please fill out this field.' : field.type === 'email' ? 'Please enter a valid email address.' : 'Please check this field.';
  };
  contactForm.addEventListener('invalid', event => showFieldError(event.target), true);
  fields.forEach(field => field.addEventListener('input', () => {
    if (field.hasAttribute('aria-invalid')) showFieldError(field);
  }));
}

document.querySelector('#year').textContent = new Date().getFullYear();

}

}
initCovour();
document.addEventListener("shopify:section:load", initCovour);
document.addEventListener("shopify:section:select", event => { const modal = event.target.querySelector("dialog"); if (modal && !modal.open) { modal.showModal(); document.body.classList.add("modal-open"); } });

document.addEventListener("shopify:section:unload", event => { if (event.target.querySelector("dialog")) document.body.classList.remove("modal-open"); });
